(ns frontend.ui.component.lp-portal.voima-components.card.style
  (:require
   [common.util :as cu]
   [frontend.ui.component.grid.style :as grid]
   [frontend.ui.style.theme.core :as theme]
   [garden.units :refer [px]]))

;; This component is specific to LP Portal so colors don't need to refer to `[:table :tr]` but
;; can directly use `[:palette :grey-10]` as this component will never use any other theme.

(defn simple-body
  [props]
  {:border           (when (:border? props) "1px solid")
   :border-radius    "15px"
   :padding          (if (:logo? props) "8px" "16px")
   :background-color (cond (:removed-since-empty? props)
                           (theme/color [:palette :danger])
                           (cu/blank-value? (:background-color props))
                           (theme/color [:content-card :body :bg])
                           :else
                           (:background-color props))

   :border-color     (theme/color [:content-card :row :border])})

(def ^:private width-too-small
  {:screen :only :max-width (px 992)})

(defn children-row
  []
  (with-meta
    {:display        "flex"
     :flex-direction "row"
     :border         "1px solid"
     :border-color   (theme/color [:content-card :row :border])
     :border-radius  "16px"}
    {:media
     {width-too-small
      {:flex-direction "column"}}}))

(defn main-child
  [split]
  (with-meta
    {:width            (grid/->width split)
     :padding          "16px"
     :background-color (theme/color [:content-card :child :primary :bg])
     :border-radius    "16px 0 0 16px"}
    {:media
     {width-too-small
      {:width         "100%"
       :border-radius "16px 16px 0 0"}}}))

(defn secondary-child
  [split props]
  (with-meta
    {:width             (grid/->width split)
     :background-color  (if (cu/blank-value? (:background-color props))
                          (theme/color [:content-card :child :secondary :bg])
                          (:background-color props))
     :padding           "5px"
     :border-radius     "0 16px 16px 0"
     :border-left       "1px solid"
     :border-left-color (theme/color [:content-card :row :border])}
    {:media
     {width-too-small
      {:width         "100%"
       :border-radius "0 0 16px 16px"}}}))

(defn card
  [blank-title? props]
  (merge {:min-width     0
          :width         "100%"
          :padding       "8px 0 0"
          :margin-bottom (when-not (cu/blank-value? (:margin-bottom props))
                           (:margin-bottom props))
          :font-size     "14px"
          :line-height   "2"}
         (cond (and blank-title? (not (:logo? props)) (:image? props))
               {:margin-top "0px"}
               blank-title?
               {:margin-top "-20px"}
               :else {:margin-top "0px"})))

(defn title
  [props]
  (let [preserve-title-case? (:preserve-title-case? props)]
    (merge {:padding        (cond (:blank-title? props)
                                  "0px"
                                  (= (theme/get-theme) :theme.lp-portal/lifeline)
                                  "12px 12px 0px 12px"
                                  :else
                                  "12px")
            :color          (theme/color [:content-card :title :color])
            :font-size      "14px"
            :font-weight    "bold"
            :letter-spacing "2.2px"
            :line-height    1.5
            :text-transform (if preserve-title-case?
                              :none
                              :uppercase)
            :width          "80%"}
           (when (:edit-mode? props)
             {:white-space   "normal"
              :word-break    "break-word"
              :overflow-wrap "anywhere"
              :max-width     "calc(100% - 230px)"})
           (when (:centered-title? props)
             {:display         "flex"
              :justify-content "center"
              :max-width       "100%"})
           (when (= (theme/get-theme) :theme.lp-portal/lifeline)
             {:font-family "SuperiorTitleBlack"}))))

(defn free-text-card
  []
  {:margin-top "-8px"})
